/**
 * When #menu-drawer is rendered outside <details>, sync:
 * - .menu-drawer--open on the panel
 * - body overflow hidden while open
 * - overlay visibility + click to close (same as hamburger trigger)
 *
 * Supports #Details-menu-drawer-container as either <details> (native toggle) or
 * <div data-menu-drawer-root> (custom toggle via global.js HeaderDrawer).
 */
(function () {
  function init() {
    var root = document.getElementById('Details-menu-drawer-container');
    var panel = document.getElementById('menu-drawer');
    var overlay = document.getElementById('menu-drawer_overlay');
    if (!root || !panel || !panel.classList.contains('menu-drawer--detached')) return;

    var bodyOverflowPrev = '';

    function isRootOpen() {
      return root.tagName === 'DETAILS' ? root.open : root.hasAttribute('open');
    }

    function setOpenState(isOpen) {
      if (isOpen) {
        panel.classList.add('menu-drawer--open');
        if (overlay) overlay.classList.add('menu-drawer__overlay--visible');
        bodyOverflowPrev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      } else {
        panel.classList.remove('menu-drawer--open');
        if (overlay) overlay.classList.remove('menu-drawer__overlay--visible');
        document.body.style.overflow = bodyOverflowPrev || '';
        bodyOverflowPrev = '';
      }
    }

    function syncFromRoot() {
      setOpenState(isRootOpen());
    }

    if (root.tagName === 'DETAILS') {
      root.addEventListener('toggle', syncFromRoot);
    } else {
      new MutationObserver(syncFromRoot).observe(root, {
        attributes: true,
        attributeFilter: ['open'],
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        var trigger =
          root.querySelector('[data-menu-drawer-trigger]') ||
          root.querySelector('.header__icon--menu') ||
          root.querySelector('summary.header__icon--menu');
        if (trigger) trigger.click();
      });
    }

    if (isRootOpen()) {
      setOpenState(true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
